import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "../../../app/store";

export enum MenuItem {
    LOCATIONS,
    FRANCHISES,
    ASSISTANTS,
    TRANSCRIPTS,
    ANALYTICS,
    KNOWLEDGE_SETTINGS,
    FEEDBACK,
    BULK_UPDATE
}

export interface BotState {
    selectedMenuItem: MenuItem
}

const initialState: BotState = {
    selectedMenuItem: MenuItem.LOCATIONS
};


export const platformSlice = createSlice({
    name: 'platform',
    initialState,
    reducers: {
        updateSelectedMenuItem: (state, {payload}: PayloadAction<MenuItem>) => {
            state.selectedMenuItem = payload
        },
    },
    extraReducers: (builder) => {
    },
});

export const {
    updateSelectedMenuItem
} = platformSlice.actions;

export const selectedMenuItemSelector = (state: RootState): MenuItem => state.platform.selectedMenuItem;
